<template>
    <div class="vb-field-editor-dash"
         @mouseleave="hover = false"
         @mouseover="readOnly ? hover = false : hover = true"
         :style="{display: display || 'flex'}">
        <v-icon class="vb-field-icon"
                v-if="icon">
            {{icon}}
        </v-icon>

        <div class="vb-field-info">
            <div class="vb-field-editor-dash__title"
                 v-if="title">
                {{title}}
            </div>

            <div class="vb-field-editor-dash__container">
                <div class="vb-field-editor-dash__input"
                     :data-ph="placeholder"
                     contenteditable="false"
                     aria-placeholder="texto"
                     ref="fieldEditor"
                     @click="openEditing = true">{{ data ? $options.filters.extraDataAppearance(data) : value }}</div>
                <InlineEditor @onSave="update($event)"
                              :field-type="data.type || 'text'"
                              :label="data.field || title"
                              :options="data.options"
                              :value="data.value"
                              option-label="name"
                              :isEditingOpen="openEditing"
                              @menuClosed="openEditing=false"
                              option-value="name"
                              v-if="data && !readOnly">
                </InlineEditor>
                <InlineEditor @onSave="update($event)"
                              :field-type="'text'"
                              :label="title"
                              :value="value"
                              :isEditingOpen="openEditing"
                              @menuClosed="openEditing=false"
                              v-else-if="!data && !readOnly">
                </InlineEditor>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data: () => ({
    hover: false,
    showActions: false,
    openEditing: false
  }),
  methods: {
    update (event) {
      if (this.readOnly) return

      this.$emit('update', event)
    }
  },
  name: 'VBFieldEditor',
  props: {
    display: String,
    icon: String,
    data: {
      type: [Number, String, Object, Boolean],
      default: false
    },
    placeholder: String,
    readOnly: Boolean,
    title: String,
    value: [String, Number]
  },
  filters: {
    extraDataAppearance (data) {
      const { value, type } = data
      if (!type) return value

      let parsedValue
      try {
        if (type === 'phone') {
          parsedValue = JSON.parse(value)
          if (parsedValue.number && parsedValue.phone) {
            return `+${parsedValue.number} ${parsedValue.phone}`
          }
        } else if (type === 'checkbox') {
          parsedValue = JSON.parse(value)
          if (Array.isArray(parsedValue)) {
            return parsedValue.join(', ')
          }
        }
        return value
      } catch (e) {
        return value
      }
    }
  }
}
</script>

<style>
    .vb-field-editor-dash {
        margin-top: 5px;
    }

    .vb-field-icon {
        margin-right: 8px;
    }

    .vb-field-info {
        display: flex;
        flex-direction: column;
    }

    .vb-field-editor-dash__title {
        color: grey;
        font-size: 12px;
        font-weight: bold;
    }

    .vb-field-editor-dash__container {
        align-items: center;
        display: flex;
        padding-right: 10px;
    }

    .vb-field-editor-dash__input {
        word-break: break-word;
    }

    .vb-field-editor-dash__input:focus {
        outline: none;
    }

    .vb-field-editor-dash__container [contentEditable=true]:empty:before {
        content:attr(data-ph);
        color: rgba(0, 0, 0, .3);
        cursor: text;
    }

    .vb-field-editor-dash__container [contentEditable=false]:empty:before {
        content:attr(data-ph);
        color: rgba(0, 0, 0, .3);
        cursor: text;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter,
    .fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
